import {Message, LoaderData} from './Model'
import {observable, action} from 'mobx'
import Theme from 'Theme'

export default class {
  @observable message?: Message = undefined
  @observable loading: string[] = []
  @observable isDesktop: boolean = false
  @observable menuSelected: string
  @observable menuSelectedConfiguracion: string
  @observable menuSelectedOperaciones: string

  constructor() {
    window.addEventListener('resize', this.setIsDesktop)
    this.setIsDesktop()
  }

  constructString = (data: LoaderData) => {
    let route = data.url
      .slice(data.baseURL!.length)
      .replace(/^([a-z\/]+).*$/, '$1')
      .replace(/\/$/, '')
    let result = data.method + '@' + route
    return result
  }

  @action
  createLoading = (data: LoaderData) => {
    this.loading.push(this.constructString(data))
  }

  @action
  removeLoading = (data?: LoaderData) => {
    if (!data) this.loading = []
    else {
      let index = this.loading!.indexOf(this.constructString(data))
      if (index > -1) {
        this.loading.splice(index, 1)
      }
    }
  }

  isLoading = (request?: string | string[]) => {
    if (!request) return false
    let requests = Array.isArray(request) ? request : [request]
    return this.loading.some(e => requests.includes(e))
  }

  newWarning(text: string) {
    this.setMessage(text, 'warning')
  }

  newError(text: string) {
    this.setMessage(text, 'error')
  }

  @action
  changeMenuSelected = (nuevo: string) => {
    this.menuSelected = nuevo;
    this.menuSelectedConfiguracion = ''
  }
  @action
  changeMenuSelectedConfiguracion = (nuevo: string) => {
    this.menuSelectedConfiguracion = nuevo;
  }
  @action
  changeMenuSelectedOperaciones = (nuevo: string) => {
    this.menuSelectedOperaciones = nuevo;
  }

  @action
  private setMessage = (text?: string, type?: string) => {
    if (type && text) {
      this.message = {text, type}
      this.hideMessage()
    } else this.message = undefined
  }

  @action
  private setIsDesktop = () => {
    this.isDesktop = /*!this.isMobileDevice()*/
      window.innerWidth >= Theme.common.devices.desktopWidth &&
      window.innerHeight >= Theme.common.devices.mobileHeight
  }

  private isMobileDevice() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  private hideMessage = () => {
    setTimeout(() => {
      this.setMessage()
    }, 3000)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/UI/Store.ts